/* eslint-disable no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api"; 

export const get_event_details = createAsyncThunk(
    'home/get_event_details', //eventDetails
    async(customerId, { rejectWithValue, fulfillWithValue }) => {
        //console.log(customerId)
        try {
            //const {data} = await api.get(`/home/product/get-cart-products/${userId}`) 
            //eventDetails eventDetailsCustomerDashboard /${customerId}
            const {data} = await api.get(`/home/get-event-details/${customerId}`) 
            //console.log(data)
            //console.log(userId)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const update_event_details = createAsyncThunk(
    'home/update_event_details',//home
        async(info, { rejectWithValue,fulfillWithValue }) => {
        //console.log(info)
        try {
            const {data} = await api.put('/home/update-event-details', info) 
            // console.log('info ', info)
            //console.log('update_event_details data ', data) 
            //console.log(eventDetails)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
     }
)
// End Method 

//router.put('/home/update-event-details-not-deposit', eventDetailsController.update_event_details_not_deposit)

export const update_event_details_not_deposit = createAsyncThunk(
    'home/update_event_details_not_deposit',//home
        async(info, { rejectWithValue,fulfillWithValue }) => {
        //console.log(info)
        try {
            const {data} = await api.put('/home/update-event-details-not-deposit', info) 
            // console.log('info ', info)
            //console.log('update_event_details data ', data) 
            //console.log(eventDetails)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const update_event_details_deposit_only = createAsyncThunk(
    'home/update_event_details_deposit_only',//home
    async(info, { rejectWithValue,fulfillWithValue }) => {
        //console.log(info)
        try {
            const {data} = await api.put('/home/update-event-details-deposit-only', info) 
            // console.log('info ', info)
            // console.log('update_event_details data ', data) 
            // console.log(eventDetails)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const update_event_details_balance = createAsyncThunk(
    'home/update_event_details_balance',//home
    async(info, { rejectWithValue,fulfillWithValue }) => {
        //console.log(info)
        try {
            const {data} = await api.put('/home/update-event-details-balance', info) 
            // console.log('info ', info)
            // console.log('update_event_details data ', data) 
            // console.log(eventDetails)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const update_event_details_sellerPackage = createAsyncThunk(
    'home/update_event_details_sellerPackage', 
        async(info, { rejectWithValue,fulfillWithValue }) => {
        //console.log(info)
        try {
            const {data} = await api.put('/home/update-event-details-sellerPackage', info) 
            // console.log('info ', info)
            //console.log('update_event_details data ', data) 
            //console.log(eventDetails)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const update_event_details_floorPlan = createAsyncThunk(
    'home/update_event_details_floorPlan', 
    async(info, { rejectWithValue,fulfillWithValue }) => {
        //console.log('fp', info)
        try {
            const {data} = await api.put('/home/update-event-details-floorPlan', info) 
            //console.log('info ', info)
            //console.log('update_event_details data ', data) 
            //console.log(eventDetails)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const update_event_details_selectedGalleryImages = createAsyncThunk(
    'home/update_event_details_selectedGalleryImages', 
        async(info, { rejectWithValue,fulfillWithValue }) => {
        //console.log(info)
        try {
            const {data} = await api.put('/home/update-event-details-selectedGalleryImages', info) 
            // console.log('info ', info)
            //console.log('update_event_details data ', data) 
            //console.log(eventDetails)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const eventDetailsReducer = createSlice({
    name: 'eventDetails',
    initialState:{
        depositGiven: false,
        depositAmountPaid: 0,
        balancePaid: false,
        balanceAmountPaid: 0,
        eventName: '',
        venueName: '',
        venueAddress: '',
        eventType: '', 
        eventDate: '', 
        eventStartTime: '',
        eventServiceType: '', 
        eventPlaceSettings: '', 
        eventGuestTableclothColor:'', 
        eventBuffetTableclothColor: '',
        eventNapkinColor: '',
        venueManagerContactInfo: '', 
        eventGuestCount: 0, 
        eventNotes: '',
        floorPlanCanvasHeight: '',
        floorPlanCanvasWidth: '',
        floorPlanRoomHeight: '',
        floorPlanRoomWidth: '',
        floorPlan: '',
        customMenuProducts: '[]',
        customMenuInstructions: '',
        selectedGalleryImages: '[]',
        otherEventOptions: '[]',
        eventDetailsSellerNotes: '',
        tableRequirements: '[]', 
        utensilsAndEquipmentList: '[]', 
        eventStaffList: '[]',
        invoice: '[]',  
        eventPartsTimeLine: '[]',
        coupon: '', 
        couponDescription: '', 
        couponExpirationDate: '',

    },
    reducers : {
        messageClear : (state,_) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(get_event_details.fulfilled, (state, { payload }) => { 
            //state.successMessage = payload.message; 
            state.eventDetails = payload.eventDetails
            //console.log('eventDetailsReducer get_event_details.fulfilled payload.eventDetails ', payload.eventDetails)
            //console.log(state.cart_product_count)
        })
        .addCase(get_event_details.rejected, (state, { payload }) => {
            state.errorMessage = payload.error; 
        })
        .addCase(update_event_details.fulfilled, (state, { payload }) => {
            state.eventDetails = payload.eventDetailsUpdated;
            state.successMessage = payload.message;
        })
        .addCase(update_event_details.rejected, (state, { payload }) => {
            state.errorMessage = payload.error; 
        })
        .addCase(update_event_details_not_deposit.fulfilled, (state, { payload }) => { 
            state.eventDetails = payload.eventDetailsUpdated;
            state.successMessage = payload.message; 
        })    
        .addCase(update_event_details_not_deposit.rejected, (state, { payload }) => {
            state.errorMessage = payload.error; 
        })
       .addCase(update_event_details_sellerPackage.fulfilled, (state, { payload }) => { 
            state.eventDetails = payload.eventDetailsUpdated;
            state.successMessage = payload.message; 
        })    
        .addCase(update_event_details_sellerPackage.rejected, (state, { payload }) => {
            state.errorMessage = payload.error; 
        })
        .addCase(update_event_details_floorPlan.fulfilled, (state, { payload }) => { 
            state.eventDetails = payload.eventDetailsUpdated;
            state.successMessage = payload.message; 
        })
        .addCase(update_event_details_floorPlan.rejected, (state, { payload }) => {
            state.errorMessage = payload.error; 
        })
        .addCase(update_event_details_selectedGalleryImages.fulfilled, (state, { payload }) => { 
            state.eventDetails = payload.eventDetailsUpdated;
            state.successMessage = payload.message; 
        })
        .addCase(update_event_details_selectedGalleryImages.rejected, (state, { payload }) => {
            state.errorMessage = payload.error; 
        })
    }
})

export const {messageClear} = eventDetailsReducer.actions
export default eventDetailsReducer.reducer
